import { memo } from "react";
import "../../assets/scss/base/pages/cart/EarnCoinsForm.scss";
import { pcoin } from "../../assets/images/cart";


const EarnCoinsForm = memo(({ earningPCoin }) => {

  return (
    <div className="frame-wrapper2">
      <div className="you-can-earn-50-p-coins-for-co-parent">
        <div className="you-can-earn">
          You can earn up to{" "}
          <img className="p-coin-icon2EarnCoinsForm" alt="pcoin" src={pcoin} />{" "}
          {Math.max(Math.round(Number(earningPCoin) || 0), 0)} P-Coins for completing this purchase
        </div>
      </div>
    </div>
  );
});

export default EarnCoinsForm;
